import {
  Component,
  NgZone,
  OnInit,
  ViewChild,
  HostListener,
  ChangeDetectionStrategy
} from "@angular/core";
import { CommonModule } from "@angular/common";
import {
  DxButtonModule,
  DxDataGridModule,
  DxFormComponent,
  DxFormModule,
  DxSwitchModule,
  DxTextBoxModule,
  DxValidationGroupModule,
  DxValidatorModule,
} from "devextreme-angular";
import { GridConnectionService } from "src/app/services/grid-connection.service";
import { Router } from "@angular/router";
import { AppGlobals } from "src/app/app.globals";
import { DeletePopupComponent } from "src/app/components/delete-popup/delete-popup.component";
import { GpdButtonComponent } from "src/app/components/gpd-button/gpd-button.component";
import { GenericPopupComponent, PopupButton } from "src/app/components/generic-popup/generic-popup.component";

import { ActivityLogService } from "src/app/services/activity-log.service";
import { ActivitySection } from "src/app/constants/activity-log";
@Component({
    selector: "app-grid-connection-list",
    imports: [
        CommonModule,
        DxDataGridModule,
        DxButtonModule,
        DxFormModule,
        DxValidationGroupModule,
        DxValidatorModule,
        DxTextBoxModule,
        DeletePopupComponent,
        DxSwitchModule,
        GpdButtonComponent,
        GenericPopupComponent,
    ],
    templateUrl: "./grid-connection-list.page.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ["./grid-connection-list.page.css"]
})
export class GridConnectionListComponent implements OnInit {
  private isCtrlPressed: boolean = false;

  @ViewChild("projectFavList") projectFavList: any;
  @ViewChild("newGridConnectionForm", { static: false }) newGridConnectionForm!: DxFormComponent;

  gridConnectionList: any = [];

  searchTerm: string = '';

  siteList: any = [];

  editMode: boolean = false;

  userIsAdmin: boolean = false;

  newGridConnection = {
    pipelineNr: null,
    nr: null,
    name: null,
  };
  newGridConnectionPopupVisible: boolean = false;

  addText: string = $localize`:@@newSite:New Site`;
  deleteFolderTitle: string = $localize`:@@deleteSiteFiles:Delete Site Files`;

  newSitePopupButtons: PopupButton[] = [
    {
      text: $localize`:@@cancel:Cancel`,
      onClick: () => { this.newGridConnectionPopupVisible = false; },
      type: "secondary",
    },
    {
      text: $localize`:@@confirm:Confirm`,
      onClick: () => { this.submitForm(null); },
      submitBehavior: true,
    },
  ];

  deleteFolderLeftButtons: PopupButton[] = [
    {
      text: $localize`:@@removeFolders:Remove Folders/Files`,
      onClick: () => { this.handleRemoveFolders(); },
      type: "danger",
    },
  ];

  deleteFolderButtons: PopupButton[] = [
    {
      text: $localize`:@@keepFolders:Keep Folders/Files`,
      onClick: () => { this.handleConfrimKeepFolders(); },
    },
  ];

  filterFavorites: boolean = false;
  favoritesVisible: string = localStorage.getItem("siteListFavoritesSwitch");

  pageBreadCrumb: any = {
    text: $localize`Site List/`,
    href: window.location.href,
    layer: 0,
  };

  cursorChange: any = "defaultCursor";

  constructor(
    private service: GridConnectionService,
    private router: Router,
    private ngZone: NgZone,
    private appGlobals: AppGlobals,
    private activityLog: ActivityLogService
  ) {
    if (this.favoritesVisible == "false") {
      this.filterFavorites = false;
    }

    if (this.favoritesVisible == "true") {
      this.filterFavorites = true;
    }
  }

  async ngOnInit() {
    this.activityLog.logView({ Section: ActivitySection.SITE });
    /*     if (environment.isTestEnvironment === true) { */
    this.appGlobals.SetGlobalMenuIndex(1);
    /*     } else {
      this.appGlobals.SetGlobalMenuIndex(1);
    } */

    await this.getPageData();
    //this.applyFavoritesFilter();
    this.setBooleanInLocalStorage(
      "siteListFavoritesSwitch",
      JSON.stringify(false)
    );

    this.appGlobals.$headerTitle.next($localize`:@@site:Site`);

    this.userIsAdmin = AppGlobals.UserPermissions.isAdministrator;
    AppGlobals.clearBreadCrumbInLocalStorage();
  }

  async getPageData() {
    this.service.getGridConnectionList({}).then(
      (result) => {
        if (result.hasError === true)
          AppGlobals.ShowErrorMessage(result.feedback);
        else {
          this.siteList = result.gridConnectionList;
          this.gridConnectionList = this.siteList;
        }
      },
      (error: any) => {
        AppGlobals.ShowErrorMessage(error);
      }
    );
  }

  @HostListener("document:keydown", ["$event"])
  onKeydown(event: KeyboardEvent) {
    if (event.key === "Control" || event.key === "Meta") {
      this.isCtrlPressed = true;
      this.cursorChange = "pointerCursor";
    }
  }

  @HostListener("document:keyup", ["$event"])
  onKeyup(event: KeyboardEvent) {
    if (event.key === "Control" || event.key === "Meta") {
      this.isCtrlPressed = false;
      this.cursorChange = "defaultCursor";
    }
  }

  onRowClick(e: any): void {
    if (this.isCtrlPressed) {
      this.onLeftClick(e);
    } else {
      let id = e.data.id;
      this.router.navigate(["site/" + id]);
      AppGlobals.setBreadCrumbToLocalStorage(this.pageBreadCrumb);
    }
  }

  resetNewGridConnection() {
    this.newGridConnection.nr = null;
    this.newGridConnection.name = null;
    this.newGridConnection.pipelineNr = null;
  }

  startAddGridConnection(): void {
    this.resetNewGridConnection();
    this.newGridConnectionPopupVisible = true;
  }

  toggleEditMode(arg) {
    this.editMode = arg;
  }

  submitForm(e: any) {
    if (!this.newGridConnectionForm) return;

    const validationResult = this.newGridConnectionForm.instance.validate();
    if (!validationResult.isValid) return;

    this.service
      .createNewGridConnection({
        NewGridConnectionItem: this.newGridConnection,
      })
      .then(
        (result) => {
          if (result.hasError === true)
            AppGlobals.ShowErrorMessage(result.feedback);
          else {
            this.router.navigate(["site/" + result.siteId + "/site-overview"]);
          }
        },
        (error: any) => {
          AppGlobals.ShowErrorMessage(error);
        }
      );
  }

  deletePopupVisible: boolean = false;
  deleteFolderPopupVisible: boolean = false;
  siteToDelete: any = {};

  initDeleteLocation(item: any): void {
    this.siteToDelete = item;
    this.deletePopupVisible = true;
    this.deleteFolderPopupVisible = false;
  }

  handleDeleteShowFolders(e: any): void {
    this.deletePopupVisible = false;
    this.deleteFolderPopupVisible = true;
  }

  handleConfrimKeepFolders(): void {
    this.handleDelete(false);
  }

  handleRemoveFolders(): void {
    this.handleDelete(true);
  }

  handleDelete(deleteFiles: boolean): void {
    this.deletePopupVisible = false;
    this.getPageData();

    let payload = {
      GridConnectionId: this.siteToDelete.id,
      DeleteRelatedFiles: deleteFiles,
    };

    this.service.deleteGridConnection(payload).then(
      (result) => {
        if (result.hasError === true)
          AppGlobals.ShowErrorMessage(result.feedback);
        else {
          this.siteToDelete = null;
          this.deletePopupVisible = false;
          this.deleteFolderPopupVisible = false;
          this.getPageData();
        }
      },
      (error: any) => {
        AppGlobals.ShowErrorMessage(error);
      }
    );
  }

  applyFavoritesFilter() {
    this.setBooleanInLocalStorage(
      "siteListFavoritesSwitch",
      JSON.stringify(this.filterFavorites)
    );
    if (this.filterFavorites == true) {
      this.projectFavList.instance.filter(["isFavorite", "=", true]);
      this.gridConnectionList.filter((project) => project.isFavorite === true);
    } else {
      this.projectFavList.instance.clearFilter();
      this.gridConnectionList = this.siteList;
    }
  }

  setBooleanInLocalStorage(key: string, value: string): void {
    localStorage.setItem(key, value);
  }

  onLeftClick(event: any) {
    let index = event.rowIndex;
    let selectedItem = this.gridConnectionList[index];
    let id = selectedItem.id;
    if (this.isCtrlPressed) {
      // event.preventDefault();
      const url = this.router.serializeUrl(
        this.router.createUrlTree(["grid-connection", id, "overview"])
      );
      window.open(url, "_blank");
    } else {
      this.onRowClick(event);
    }
  }
}
